/**
 * @fileoverview Constantes ESTÁTICAS de UI da página Multi unidades.
 *
 * Apenas listas que não dependem de dados do backend (opções de selects,
 * catálogo de relatórios). Os DADOS DINÂMICOS (KPIs, tabela, gráficos,
 * SMS counters) vêm do hook `useMultiUnidadesData`, que computa tudo a
 * partir do dataset primitivo (./data/seed.js + ./data/metrics.js).
 *
 * Nada aqui é hardcoded no JSX da página.
 */

export const statusOptions = [
  { value: "all", label: "Todos" },
  { value: "ok", label: "Dentro do tempo" },
  { value: "warn", label: "Atenção" },
  { value: "fail", label: "Fora do tempo" },
];

export const periodOptions = [
  { value: "today", label: "Hoje (últimas 24h)" },
  { value: "yesterday", label: "Ontem" },
  { value: "7d", label: "Últimos 7 dias" },
  { value: "30d", label: "Últimos 30 dias" },
  { value: "12m", label: "Últimos 12 meses" },
  { value: "custom", label: "Personalizado" },
];

export const exportableReports = [
  { key: "gerencial-admin", title: "Gerencial Admin", description: "Visão consolidada por subsidiária e Smart Center.", icon: "FileSpreadsheet" },
  { key: "casos-abertos", title: "Casos Abertos", description: "Lista completa de casos sem resposta no período.", icon: "FolderOpen" },
  { key: "summary", title: "Smart Center Summary – Casos Abertos", description: "Resumo agregado por Smart Center.", icon: "ClipboardList" },
  { key: "media-resposta-atendente", title: "Tempo médio 1ª resposta atendente", description: "Detalhamento por atendente e período.", icon: "Timer" },
  { key: "media-resposta-cliente", title: "Tempo médio 1ª resposta cliente", description: "Detalhamento por cliente e período.", icon: "User" },
  { key: "aguardando-resposta", title: "Casos aguardando resposta do cliente", description: "Volume de casos pendentes de retorno do cliente.", icon: "Hourglass" },
  { key: "interacao-total", title: "Tempo médio total de interação por cliente", description: "Duração consolidada das conversas.", icon: "Activity" },
  { key: "atendimentos-do-dia", title: "Total de atendimentos do dia", description: "Volume diário por unidade.", icon: "ChartLine" },
];
